import { gql } from "@apollo/client";

export const AssetTotalByConnectionStatus = gql`
  query AssetTotalByConnectionStatus(
    $runningFilter: SearchAssetFilter
    $warningFilter: SearchAssetFilter
    $errorFilter: SearchAssetFilter
    $dataBufferingFilter: SearchAssetFilter
    $offFilter: SearchAssetFilter
    $currentlyOfflineFilter: SearchAssetFilter
    $neverConnectedFilter: SearchAssetFilter
    $query: SearchAssetQuery
  ) {
    running: searchAssets(filter: $runningFilter, query: $query) {
      total
    }
    warning: searchAssets(filter: $warningFilter, query: $query) {
      total
    }
    error: searchAssets(filter: $errorFilter, query: $query) {
      total
    }
    dataBuffering: searchAssets(filter: $dataBufferingFilter, query: $query) {
      total
    }
    off: searchAssets(filter: $offFilter, query: $query) {
      total
    }
    currentlyOffline: searchAssets(filter: $currentlyOfflineFilter, query: $query) {
      total
    }
    neverConnected: searchAssets(filter: $neverConnectedFilter, query: $query) {
      total
    }
  }
`;
